import * as d3 from "d3";
import { useEffect, useRef } from "react";

type WeeklyBarChartTotalLayoutProps = {
  totalBarHeight: number;
  totalBarY: number;
};

export function WeeklyBarChartTotalLayout({ totalBarHeight, totalBarY }: WeeklyBarChartTotalLayoutProps) {
  const layerRef = useRef<SVGGElement>(null);

  useEffect(() => {
    if (!layerRef.current) return;
    const selection = d3.select(layerRef.current);

    const label = selection.selectAll<SVGTextElement, unknown>("text.total-label").data([null]);
    label
      .enter()
      .append("text")
      .attr("class", "total-label")
      .merge(label)
      .attr("x", -8)
      .attr("y", totalBarY + totalBarHeight / 2)
      .attr("text-anchor", "end")
      .attr("dominant-baseline", "middle")
      .text("合計");
  }, [totalBarHeight, totalBarY]);

  return (
    <g
      ref={layerRef}
      className="total-layout-layer"
    />
  );
}
